import BaseCheckBox from "Engine/base/ui/BaseCheckBox";
import MoneyFormat from "Base/MoneyFormat";

export default class BaseBetPopupCheckBox extends BaseCheckBox {
    constructor(data, displayData) {
        super(data, displayData);

        this.id = 0;
        this._value = 0;
        this.init();
    }

    init() {
        this.id = +this.name.replace('bet_', '');
    }

    goToFrame(frameId, force = true) {
        super.goToFrame(frameId, force);
        this.valueText = this.getChildByName('valueText');
        this.valueText.text = MoneyFormat.format(this.value, false);

        this.valueText.scale.set(1);
        if (this.valueText.origWidth > this.valueText.width) {
            this.valueText.origWidth = this.valueText.width;
            this.valueText.scale.set(this.valueText.scale.x);
        }
        this.valueText.correctPosition(null, 'center');
    }

    get value() {
        return this._value;
    }

    set value(value) {
        this._value = value;
        this.valueText.text = MoneyFormat.format(this.value, false);

        this.valueText.scale.set(1);
        if (this.valueText.origWidth > this.valueText.width) {
            this.valueText.origWidth = this.valueText.width;
            this.valueText.scale.set(this.valueText.scale.x);
        }
        this.valueText.correctPosition(null, 'center');
    }
}